export default {
  primary: '#1CEC80',
  secondary: '#FFAA00',
  black: '#000000',
  gray: '#929697',
  iconColor: '#B7C1C3',
  iconColor2: '#A2A7AF',
  borderColor: '#434949',
  primaryGradient: '#9DE870',
  arrowBg: "#AEAEAE",
  offWhite: "#FCFFFF",
  secondary: "#FFAA00",
  actionBtn1: '#1A1A1A',
  actionBtn2: '#333333',
  actionBtnTxt: "#E0E0E0",
  background: "#08080B",
  white: "#FFFFFF",
  bottomTabBackground: "#323838",
  toggleBg: '#222627',
  bottomTabInactiveText: '#B7C1C3',
  headerIconColor: "#3E4444",
  profileGradient1: "#28CF61",
  warning: "#FFBE33",
  keypadBg:'#282E2E',
  disable:"#666666",
  apricotOrange: "#FFA462",
  blue: '#5CDCFF',
  darkGray: "#4D4D4D",
  spicyCoral: '#F56940',       
  goldenSun: '#F4D03C',      
  lemonFlash: '#FDF241',
  red:"#F82C2C",
  yellow:"#FFAA00",
  searchBarBg: '#1D2122',

  //betting action status
  betYellowBg:"#E29907",
  betYellowBorder:"#FED450",
  betBlueBg:"#116897E5",
  betBlueBorder:"#1ECEFF",
  betRedBg:"#390707E5",
  betRedBorder:"#FF1E1E",
  yellowtxt:"#F9FF3D",
  lightBlue:"#41C4E9",
  inactiveColor:'#322C38',
  goldenYellow:'#ffe37b',
  green:"#17B07F",
};
